<template>
  <div class="package-quotas">
    <modal :title="title" v-if="modal" @close="switchModal">
      <unit :data="editableUnit" @close="switchModal"/>
    </modal>
    <div class="actions-add" v-if="permissionsStatus.isPackageUpdateAllowed">
      <button class="ccs-button ccs-button--white" @click="switchModal">
        <img src="@/assets/icons/add.svg" alt="" class="button-icon">
        Добавить позицию
      </button>
    </div>
    <ccs-table :data="units" :columnsDefs="columnsDefs" :defaultActions="defaultActions"
      @edit="startEditing" @delete="removeUnit">
      <template v-slot:role="props">
        {{ props.isEmpty ? 'Роль отсутствует' : props.row.role.name }}
      </template>
    </ccs-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import Table from '@/components/Table.vue';
import Modal from '@/components/Modal.vue';

import Unit from '@/components/modals/packages/Unit.vue';

export default {
  name: 'Units',
  components: {
    'ccs-table': Table,
    Modal,
    Unit,
  },
  data() {
    return {
      modal: false,
      titles: {
        new: 'Новая позиция',
        edit: 'Редактирование позиции',
      },
      editableUnit: null,
      columnsDefs: [{
        name: `name`,
        title: 'Наименование позиции',
        prop: 'name',
        type: 'text',
      }, {
        name: `description`,
        title: `Описание`,
        prop: `description`,
        type: 'text',
      }],
    };
  },
  computed: {
    ...mapState('events', ['event']),
    ...mapState('packages', ['units', 'pkg']),
    ...mapGetters('session', ['permissionsStatus']),
    title() {
      return this.editableUnit ? this.titles.edit : this.titles.new; 
    },
    defaultActions() {
      return {
        edit: this.permissionsStatus.isPackageUpdateAllowed,
        delete: this.permissionsStatus.isPackageUpdateAllowed,
      };
    },
  },
  methods: {
    ...mapActions('packages', ['getPackage', 'createUnit', 'deleteUnit']),
    switchModal() {
      this.modal = !this.modal;
      if (this.editableUnit) {
        this.editableUnit = null;
      }
    },
    startEditing(unit) {
      this.switchModal();
      this.editableUnit = Object.assign({}, unit);
    },
    async addUnit(unit) {
      try {
        await this.createUnit(unit);
        this.$toasted.success('Добавление успешно');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async removeUnit(unit, unitIndex) {
      try {
        await this.deleteUnit(unit.id);
        this.$toasted.success('Удаление успешно');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
  async mounted() {
    await this.getPackage();
  },
};
</script>

<style lang="scss" scoped>
.package-quotas {
  min-height: 100%;
  min-width: 100%;

  .quota{ 

    &-full_name {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    &-last_name {
      width: 100%;
      margin-bottom: 5px;
      font-weight: bold;
    }

  }

  .actions-add {
    margin-bottom: 30px;
  }

}
</style>
